import React from 'react';
import styled from '@emotion/styled';
import PageHeader from '../components/PageHeader';

const TermsContainer = styled.div`
  padding: 2rem;
  max-width: 1000px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const ContentSection = styled.div`
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  padding: 2rem;
  border-radius: 15px;
  border: 2px solid rgba(255, 51, 51, 0.3);
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 2rem;
  
  @media (max-width: 768px) {
    padding: 1.5rem;
  }
  
  h2 {
    color: #ff3333;
    margin-top: 2rem;
    margin-bottom: 1rem;
    font-size: 1.8rem;
    
    &:first-of-type {
      margin-top: 0;
    }
  }
  
  p {
    line-height: 1.7;
    margin-bottom: 1rem;
    font-size: 1.1rem;
  }

  ul, ol {
    margin-bottom: 1.5rem;
    padding-left: 1.5rem;
    
    li {
      margin-bottom: 0.5rem;
      line-height: 1.6;
    }
  }
`;



const TermsOfService = () => {
  return (
    <>
      <PageHeader title="Terms Of Service" highlightWord="Of" />
      <TermsContainer>
        <ContentSection>
          
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing or using <span>Red<span style={{ color: '#ff3333' }}>Cloud</span> Storage's</span> services ("Services"), you agree to be bound by these Terms of service, including all incorporated policies (Privacy Policy, Copyright Notice, Legal Notice, and Acceptable Use Policy). If you do not agree, do not use the Services.</p>
          
          <h2>2. Services</h2>
          <p><span>Red<span style={{ color: '#ff3333' }}>Cloud</span> Storage</span> provides cloud-based file storage, sharing, and collaboration tools built on the Nextcloud platform. Use of certain features may be subject to additional terms or fees outlined on our website.</p>
          
          <h2>3. Account Registration</h2>
          <ul>
            <li>You must register with accurate, complete, and up-to-date information.</li>
            <li>You are solely responsible for safeguarding your password and any activity that occurs under your account.</li>
          </ul>
          
          <h2>4. Acceptable Use Policy (AUP)</h2>
          <p>All users must comply with the following rules. Any failure to do so is a material breach of these Terms:</p>
          
          <p><strong>Lawful Conduct Only</strong></p>
          <p>You may not use the Services for any unlawful purpose or in violation of any local, state, national, or international law.</p>
          
          <p><strong>Intellectual Property</strong></p>
          <p>Do not upload, post, or share content that infringes on the copyrights, trademarks, or other rights of third parties.</p>
          
          <p><strong>Malicious Activity & Security</strong></p>
          <p>Prohibited actions include distributing malware, phishing, scanning, probing for vulnerabilities, or attempting unauthorized access to any network or account.</p>
          
          <p><strong>Spam & Unsolicited Communications</strong></p>
          <p>You may not use our Services to send unsolicited bulk messages or advertising.</p>
          
          <p><strong>Harassment & Hate Speech</strong></p>
          <p>Content that harasses, threatens, or encourages violence against individuals or groups is forbidden.</p>
          
          <p><strong>Privacy Violations</strong></p>
          <p>Do not harvest or distribute personal data without consent.</p>
          
          <p><strong>Resource Abuse</strong></p>
          <p>Excessive use of storage, bandwidth, or compute resources—beyond what your plan allows—is not permitted.</p>
          
          <p><strong>Other Prohibited Content</strong></p>
          <p>This includes (but is not limited to) child sexual abuse material, illegal pornography, extremist propaganda, or instructions facilitating wrongdoing.</p>
          
          <p><span>Red<span style={{ color: '#ff3333' }}>Cloud</span> Storage</span> reserves the right to investigate and suspend or terminate any account that violates these rules.</p>
          
          <h2>5. Privacy</h2>
          <p>Your use of the Services is also governed by our Privacy Policy, which explains how we collect, use, and protect your personal data. You can access it at <a style={{ color: '#ff3333', textDecoration: 'none' }} href="https://redcloudstorage.net/privacy">https://redcloudstorage.net/privacy</a>.</p>
          
          <h2>6. Intellectual Property Rights</h2>
          <p>All software, content, and trademarks provided by <span>Red<span style={{ color: '#ff3333' }}>Cloud</span> Storage</span> remain our property or that of our licensors. You may not copy, distribute, modify, or create derivative works without express permission.</p>
          
          <h2>7. Disclaimers</h2>
          <p>THE SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND. WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.</p>
          
          <h2>8. Limitation of Liability</h2>
          <p>TO THE MAXIMUM EXTENT PERMITTED BY LAW, <span>Red<span style={{ color: '#ff3333' }}>Cloud</span> Storage</span> SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING FROM YOUR USE OF THE SERVICES, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.</p>
          
          <h2>9. Termination</h2>
          <p>We may suspend or terminate your access immediately upon any breach of these Terms. Upon termination, you must cease all use of the Services, and certain sections (e.g., Intellectual Property, Disclaimers, Limitation of Liability) will survive.</p>
          
          <h2>10. Changes to Terms</h2>
          <p>We may amend these Terms at any time by posting updates on our website. Continued use of the Services after changes constitutes acceptance of the new Terms.</p>
          
          <h2>11. Governing Law</h2>
          <p>These Terms are governed by the laws of the jurisdiction where <span>Red<span style={{ color: '#ff3333' }}>Cloud</span> Storage</span> is headquartered, without regard to conflict-of-law principles.</p>
          
          <h2>12. Contact</h2>
          <p>If you have any questions about these Terms or need support, please contact us at:</p>
          <p>General support: <a style={{ color: '#ff3333', textDecoration: 'none' }} href="mailto:support@redcloudstorage.net">support@redcloudstorage.net</a></p>
          <p>Abuse reports: <a style={{ color: '#ff3333', textDecoration: 'none' }} href="mailto:abuse-policy@redcloudstorage.net">abuse-policy@redcloudstorage.net</a></p>
          
          <p>By using our Services, you acknowledge that you have read, understood, and agreed to be bound by these Terms of service, including the embedded Acceptable Use Policy.</p>
          
          <p>Last updated: May 20, 2025</p>
        </ContentSection>
      </TermsContainer>
    </>
  );
};

export default TermsOfService;
